import React, { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { DIRECT_PUBLIC_GIST_ROUTE } from "../../services/graphql/queriesMutations";
import type { GistType, SubjectType } from "../../services/types";
import styles from "./PublicPages.module.css";

type DirectPublicGistRouteData = {
  directPublicGistRoute: {
    canonicalUrl: string;
    shouldRedirect: boolean;
    subject: SubjectType;
    gist: GistType;
  };
};

const DirectPublicGistPage: React.FC = () => {
  const { gistPublicId = "" } = useParams();
  const navigate = useNavigate();

  const { data, loading, error } = useQuery<DirectPublicGistRouteData>(DIRECT_PUBLIC_GIST_ROUTE, {
    variables: { gistPublicId },
    skip: !gistPublicId,
  });

  const route = data?.directPublicGistRoute;

  useEffect(() => {
    if (route?.canonicalUrl) {
      navigate(route.canonicalUrl, { replace: true });
    }
  }, [navigate, route]);

  if (loading || route?.canonicalUrl) {
    return <div className={styles.page}><main className={styles.shell}>Opening public gist…</main></div>;
  }

  if (error || !gistPublicId) {
    return (
      <div className={styles.page}>
        <main className={styles.shell}>
          <div className={styles.errorBox}>
            Public gist not found or not available. <Link className={styles.inlineLink} to="/">Return to home</Link>.
          </div>
        </main>
      </div>
    );
  }

  return <div className={styles.page}><main className={styles.shell}>Opening public gist…</main></div>;
};

export default DirectPublicGistPage;
